import { defineStore } from "pinia";
import base from "./base"

export const useShipmentsStore = defineStore('shipments', {
    state: () => ({
        shipments: [],
        containers: [],
        locations: [],
        companies: [],
    }),
    getters: {
    },

    actions: {
        // Reset store
        resetStore() {
            this.shipments = []
            this.containers = []
            this.locations = []
            this.companies = []
        },

        // Sync mutations
        setShipments: base.actions.setter("shipments"),
        setExternalShipments: base.actions.setter("externalShipments"),
        setOpenShipments: base.actions.setter("openShipments"),
        setClosedShipments: base.actions.setter("closedShipments"),
        createShipment: base.actions.creator("shipments"),
        updateShipment: base.actions.updater("shipments"),
        removeShipment: base.actions.remover("shipments"),

        // Async backend actions
        loadShipments: base.actions.loader("shipments/", "Shipments"),
        // loadExternalShipments: base.actions.loader("external/shipments/", "ExternalShipments"),
        // loadOpenShipments: base.actions.loader("shipments/open_shipments/", "OpenShipments"),
        // loadClosedShipments: base.actions.loader("shipments/closed_shipments/", "ClosedShipments"),
        postShipment: base.actions.poster("shipments/", "Shipment"),
        putShipment: base.actions.putter("shipments/", "Shipment"),
        deleteShipment: base.actions.deleter("shipments/", "Shipment"),
        refreshShipment: base.actions.refresher("shipments/", "Shipment"),

        // // Método para cargar shipments en dos etapas
        // async loadShipmentsInStages() {
        //     try {
        //         // Limpiar shipments existentes
        //         this.shipments = [];

        //         // Etapa 1: Cargar shipments abiertos (más rápido)
        //         console.log('Loading open shipments...');
        //         const openShipments = await this.loadOpenShipments();

        //         // Etapa 2: Cargar shipments cerrados (en background)
        //         console.log('Loading closed shipments...');
        //         const closedShipments = await this.loadClosedShipments();

        //         // Combinar ambos resultados
        //         this.shipments = [...(openShipments || []), ...(closedShipments || [])];

        //         console.log(`Total shipments loaded: ${this.shipments.length}`);
        //         return this.shipments;
        //     } catch (error) {
        //         console.error('Error loading shipments in stages:', error);
        //         throw error;
        //     }
        // },

        // // Método para buscar shipments con término de búsqueda
        // async searchShipments(searchTerm, status = null) {
        //     try {
        //         const params = searchTerm ? `?search=${encodeURIComponent(searchTerm)}` : '';

        //         if (status === 'open') {
        //             return await this.loadOpenShipments(params);
        //         } else if (status === 'closed') {
        //             return await this.loadClosedShipments(params);
        //         } else {
        //             // Cargar ambos si no se especifica status
        //             return await this.loadShipmentsInStages(searchTerm);
        //         }
        //     } catch (error) {
        //         console.error('Error searching shipments:', error);
        //         throw error;
        //     }
        // },


        // Sync mutations
        setContainers: base.actions.setter("containers"),
        createContainer: base.actions.creator("containers"),
        updateContainer: base.actions.updater("containers"),
        removeContainer: base.actions.remover("containers"),
        // Async backend actions
        loadContainers: base.actions.loader("containers/", "Containers"),
        postContainer: base.actions.poster("containers/", "Container"),
        putContainer: base.actions.putter("containers/", "Container"),
        deleteContainer: base.actions.deleter("containers/", "Container"),

        // Sync mutations
        setLocations: base.actions.setter("locations"),
        createLocation: base.actions.creator("locations"),
        updateLocation: base.actions.updater("locations"),
        removeLocation: base.actions.remover("locations"),
        // Async backend actions
        loadLocations: base.actions.loader("locations/", "Locations"),
        postLocation: base.actions.poster("locations/", "Location"),
        putLocation: base.actions.putter("locations/", "Location"),
        deleteLocation: base.actions.deleter("locations/", "Location"),

        // Sync mutations
        setCompanies: base.actions.setter("companies"),
        createCompany: base.actions.creator("companies"),
        updateCompany: base.actions.updater("companies"),
        removeCompany: base.actions.remover("companies"),
        // Async backend actions
        loadCompanies: base.actions.loader("companies/", "Companies"),
        postCompany: base.actions.poster("companies/", "Company"),
        putCompany: base.actions.putter("companies/", "Company"),
        deleteCompany: base.actions.deleter("companies/", "Company"),

    },
})
